import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Udcs } from "../Udcs/udcs";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UdcsService {
    private api: string = '/api/udcs';
    
    constructor(private http: HttpClient){}
  
    getUdcList(): Observable<Udcs[]> {
      const coIdRespaldo = typeof window !== 'undefined' 
        ? (sessionStorage.getItem('coId') || '') 
        : ''; 
      return this.http.get<Udcs[]>(`${this.api}?coIdFallback=${coIdRespaldo}`);
    }

    createUdc(udcs: Udcs): Observable<Udcs>{
        return this.http.post<Udcs>(this.api, udcs);
    }

    deleteUdcById(id: number): Observable<any>{
      return this.http.delete(`${this.api}/${id}`);
    }

    getMarcasAutos(): Observable<Udcs[]> { // 🛠️ Tipado estricto Udcs[] en lugar de any[]
      return this.http.get<Udcs[]>(`${this.api}/marcas?system=AUTOS&key=MARCAS`);
    }

    getTarifasUdc(): Observable<Udcs[]> { // 🛠️ Tipado estricto Udcs[] en lugar de any[]
      return this.http.get<Udcs[]>(`${this.api}/tarifas?system=TALLER&key=GRAVEDAD`);
    }    

    getSubmarcasPorMarca(codigoMarca: string): Observable<Udcs[]> {
      // 🛡️ SANEADO: encodeURIComponent evita que marcas con espacios (ej: 'ALFA ROMEO') rompan la petición HTTP
      const marcaSanitizada = encodeURIComponent(codigoMarca.trim());
      return this.http.get<Udcs[]>(`${this.api}/submarcas?system=AUTOS&key=SUBMARCAS&marca=${marcaSanitizada}`);
    }

    getRangoAnios(): Observable<number[]> {
      return this.http.get<number[]>(`${this.api}/rango-anios`);
    }

    getGirosEconomicos(): Observable<Udcs[]> {
      return this.http.get<Udcs[]>(`${this.api}/giros?system=55&key=GE`);
    }

    getPaisesMundo(): Observable<Udcs[]> {
      return this.http.get<Udcs[]>(`${this.api}/paises`);
    }

    getEstadosPorPais(codigoPais: string): Observable<Udcs[]> {
      const paisSanitizado = encodeURIComponent(codigoPais.trim());
      return this.http.get<Udcs[]>(`${this.api}/estados?pais=${paisSanitizado}`);
    }      

    getCatBySystemCode(systemCode: string): Observable<Udcs[]> {
      const coIdRespaldo = typeof window !== 'undefined' 
        ? (sessionStorage.getItem('coId') || '') 
        : ''; 
      const systemSanitizado = encodeURIComponent(systemCode.trim());
      return this.http.get<Udcs[]>(`${this.api}/sistema/${systemSanitizado}?coIdFallback=${coIdRespaldo}`);
    }
}